var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-dialog"
  }, [_c('dialogBox', {
    attrs: {
      "opacity": 0.67
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('div', {
    staticClass: "img",
    style: _vm.styleBg,
    on: {
      "click": _vm.clickContent
    }
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeBtn
    }
  }), _vm._t("default")], 2)])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };